<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <form class="form-horizontal" @submit.prevent="onSubmit">
          <card class="text-left">
            <template slot="header">
              <h4 class="card-title">유저 제보 스케줄 일정</h4>
              <base-button v-if="scheduleId" @click="showOriginalSchedule" type="default">원본보기</base-button>
            </template>
            <div>
              <div class="row">
                <label class="col-sm-2 col-form-label">타입</label>
                <div class="col-sm-10 checkbox-radios">
                  <span v-for="(n, index) in scheduleTypes" :key="index">
                    <base-radio :name="n.id.toString()" inline v-model="scheduleType">{{ n.name }}</base-radio>
                  </span>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">알림 타입</label>
                <div class="col-sm-4">
                  <el-select multiple class="select-primary" size="large" placeholder="알림타입" v-model="scheduleNotificationTypes.typeIds">
                    <el-option
                      v-for="option in scheduleNotificationTypes.options"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </el-select>
                </div>
                <div class="col-sm-6">
                  {{ scheduleNotificationTimes.toString() }}
                </div>
              </div>

              <div class="row" v-if="selectedScheduleMetadataTypes.length > 0">
                <label class="col-sm-2 col-form-label">메타데이터</label>
                <div class="col-sm-4">
                  <el-select class="select-primary" size="large" placeholder="메타데이터" v-model="scheduleMetadataType">
                    <el-option
                      v-for="option in selectedScheduleMetadataTypes"
                      class="select-primary"
                      :value="option.id"
                      :label="option.name"
                      :key="option.name"
                    ></el-option>
                  </el-select>
                </div>
                <div v-if="selectedScheduleMetadataType.hasLocation === 1" class="col-sm-4">
                  <v-select
                    class="select-primary"
                    size="large"
                    placeholder="국가선택"
                    :clearable="false"
                    :options="countryCodes"
                    label="name"
                    :reduce="(label) => label.isoCode"
                    v-model="countryCode"
                  >
                  </v-select>
                  <v-select
                    class="select-primary"
                    size="large"
                    placeholder="도시선택"
                    :clearable="false"
                    :options="cities"
                    label="name"
                    :reduce="(label) => label.name"
                    v-model="city"
                  >
                  </v-select>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">타이틀</label>
                <div class="col-sm-10">
                  <base-input placeholder="타이틀" v-model="title" required>
                    <span slot="helpBlock" class="form-text"></span>
                  </base-input>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">템플릿</label>
                <div class="col-sm-10">
                  <TemplateSelect type="schedule" @templateApply="applyTemplate"></TemplateSelect>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">내용</label>
                <div class="col-sm-10">
                  <base-input placeholder="내용">
                    <textarea class="form-control" id="content" rows="3" v-model="content"></textarea>
                  </base-input>
                </div>
              </div>
              <div>
                <div class="row">
                  <label class="col-sm-2 col-form-label">컨텐츠추가</label>

                  <base-button @click="addContent" type="success">+</base-button>
                </div>
                <draggable class="row" v-model="contents" group="people" @start="drag = true" @end="drag = false">
                  <div class="col-sm-12" v-for="(content, index) in contents">
                    <div class="row">
                      <div class="col-sm-2">
                        <span v-for="(n, index) in contentTypes" :key="index">
                          <base-radio :name="n.type" inline v-model="content.contentType">{{ n.name }}</base-radio>
                        </span>
                      </div>

                      <div v-if="content.contentType === 'I'" class="col-sm-8">
                        <div class="row">
                          <div class="col-sm-4">
                            <BlipFileUploadZone
                              :upload-category="7"
                              :index="index"
                              :maxFiles="1"
                              :fileUrl="content.imageUrl"
                              @onChangeFileIds="onMediaFileIdChange"
                            />
                          </div>
                          <div class="col-sm-3">
                            <label class="col-sm-2 col-form-label">이미지 비율</label>
                            <div class="col-sm-10">
                              <el-select class="select-primary" size="large" placeholder="이미지비율" @change="onRatioChange(content)" v-model="content.ratio">
                                <el-option
                                  v-for="option in ratios"
                                  class="select-primary"
                                  :value="option.value"
                                  :label="option.label"
                                  :key="option.label"
                                ></el-option>
                              </el-select>
                            </div>
                          </div>
                          <div v-if="content.imageUrl && content.ratio" class="col-sm-4">
                            <label class="col-sm-2 col-form-label">표시영역</label>
                            <div class="col-sm-10">
                              <cropper
                                :ref="'cropper' + index"
                                classname="cropper"
                                :src="content.imageUrl"
                                :stencilProps="{
                                  aspectRatio: content.aspectRatio,
                                }"
                                :canvas="false"
                                @change="onCropperChange"
                              ></cropper>
                              <base-button @click="cropImage(content.imageFileId, index)"> 적용 </base-button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-8" v-if="content.contentType === 'V'">
                        <div class="row">
                          <div class="col-sm-6">
                            <BlipFileUploadZone
                              :upload-category="7"
                              :index="index"
                              :maxFiles="1"
                              :fileUrl="content.imageUrl"
                              @onChangeFileIds="onMediaFileIdChange"
                            />
                          </div>
                          <div class="col-sm-6">
                            <div class="row">
                              <label class="col-sm-2 col-form-label">URL</label>
                              <div class="col-sm-10">
                                <base-input placeholder="url" v-model="content.path">
                                  <span slot="helpBlock" class="form-text" />
                                </base-input>
                              </div>
                            </div>
                            <div class="row">
                              <label class="col-sm-2 col-form-label"></label>
                              <div class="col-sm-10">
                                <base-button @click="getMetadata(content.path, index)" type="default">썸네일불러오기</base-button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-sm-1 col-form-label">타이틀</label>
                          <div class="col-sm-3">
                            <base-input placeholder="타이틀" v-model="content.title">
                              <span slot="helpBlock" class="form-text" />
                            </base-input>
                          </div>
                          <label class="col-sm-1 col-form-label">서브타이틀</label>
                          <div class="col-sm-3">
                            <base-input placeholder="서브타이틀" v-model="content.subtitle">
                              <span slot="helpBlock" class="form-text" />
                            </base-input>
                          </div>
                          <label class="col-sm-1 col-form-label">재생시간(초)</label>
                          <div class="col-sm-3">
                            <base-input placeholder="재생시간" v-model="content.duration">
                              <span slot="helpBlock" class="form-text" />
                            </base-input>
                          </div>
                        </div>
                      </div>

                      <div v-if="content.contentType === 'T'" class="col-sm-8">
                        <label class="col-sm-2 col-form-label">내용</label>
                        <el-popover trigger="hover" placement="top">
                          <div>
                            <div class="popover-body">
                              [링크텍스트](링크URL) 입력시, 링크텍스트에 하이퍼링크가 적용됩니다<br />
                              ex) [블립](https://www.blip.kr) 입력시, 블립에 하이퍼링크 적용
                            </div>
                          </div>
                          <base-button slot="reference"> ? </base-button>
                        </el-popover>
                        <base-input placeholder="내용">
                          <textarea class="form-control" rows="10" v-model="content.description"></textarea>
                        </base-input>
                      </div>

                      <base-button @click="removeContent(index)" type="default">-</base-button>
                    </div>
                    <div class="row">&nbsp;</div>
                  </div>
                </draggable>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">위치</label>
                <div class="col-sm-2">
                  <el-select class="select-primary" size="large" placeholder="위치" v-model="location.type">
                    <el-option
                      v-for="option in location.options"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </el-select>
                </div>
                <div v-if="location.type !== null" class="col-sm-8">
                  <base-input placeholder="위치" v-model="location.name">
                    <span slot="helpBlock" class="form-text"></span>
                  </base-input>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">참여멤버</label>
                <div class="col-sm-10 checkbox-radios">
                  <span v-for="(n, index) in members" :key="index">
                    <base-checkbox v-model="members[index].value" inline>{{ n.name }}</base-checkbox>
                  </span>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">노출여부</label>
                <div class="col-sm-4">
                  <base-switch v-model="isShow" type="primary" on-text="ON" off-text="OFF"></base-switch>
                </div>
                <label class="col-sm-2 col-form-label">시작시간이후 공개</label>
                <div class="col-sm-4">
                  <base-switch v-model="isImportant" type="primary" on-text="ON" off-text="OFF"></base-switch>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">하루종일</label>
                <div class="col-sm-4">
                  <base-switch v-model="isAllday" type="primary" on-text="ON" off-text="OFF"></base-switch>
                </div>
                <label class="col-sm-2 col-form-label">종료시간숨김</label>
                <div class="col-sm-4">
                  <base-switch v-model="isEndTimeHidden" type="primary" on-text="ON" off-text="OFF"></base-switch>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">시작시간</label>
                <div class="col-sm-4">
                  <base-input v-if="isAllday">
                    <el-date-picker type="date" placeholder="시작시간" v-model="startTime"></el-date-picker>
                  </base-input>
                  <base-input v-else>
                    <el-date-picker type="datetime" placeholder="시작시간" v-model="startTime"></el-date-picker>
                  </base-input>
                </div>
                <label class="col-sm-2 col-form-label">종료시간</label>
                <div class="col-sm-4">
                  <base-input v-if="isAllday">
                    <el-date-picker type="date" placeholder="종료시간" v-model="endTime"></el-date-picker>
                  </base-input>
                  <base-input v-else>
                    <el-date-picker type="datetime" placeholder="종료시간" v-model="endTime"></el-date-picker>
                  </base-input>
                </div>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-2 col-form-label">스케줄오픈시간</label>
              <div class="col-sm-4">
                <base-input>
                  <el-date-picker type="datetime" placeholder="오픈시간" v-model="openTime"></el-date-picker>
                </base-input>
              </div>
            </div>

            <div class="row">
              <label class="col-sm-2 col-form-label">반복여부</label>
              <div class="col-sm-4">
                <el-select class="select-primary" size="large" placeholder="반복선택" v-model="repeat.repeatId">
                  <el-option
                    v-for="option in repeat.options"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  ></el-option>
                </el-select>
              </div>

              <label v-if="repeat.repeatId" class="col-sm-2 col-form-label">반복기간</label>
              <div v-if="repeat.repeatId" class="col-sm-4">
                <base-input>
                  <el-date-picker type="date" placeholder="반복시작" v-model="repeat.repeatStartDate"></el-date-picker>
                </base-input>
                <base-input>
                  <el-date-picker type="date" placeholder="반복종료" v-model="repeat.repeatEndDate"></el-date-picker>
                </base-input>
              </div>
            </div>
            <div v-if="repeat.repeatId && scheduleId" class="row">
              <label class="col-sm-2 col-form-label">일괄적용</label>
              <div class="col-sm-4">
                <base-switch v-model="isSaveAll" type="primary" on-text="ON" off-text="OFF"></base-switch>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-2 col-form-label">유저아이디</label>
              <div class="col-sm-4">{{ nickname }}({{ userId }})</div>
            </div>
          </card>

          <div class="row">
            <div class="col-md-12">
              <el-table :data="events" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
                <el-table-column type="selection" :min-width="50" align="right">
                  <div slot-scope="props">
                    <base-checkbox v-model="props.row.checked" v-if="props.row.id"></base-checkbox>
                  </div>
                </el-table-column>
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                ></el-table-column>
              </el-table>
            </div>
          </div>

          <base-button native-type="submit" type="success">등록</base-button>
          <!--          <base-button @click="acceptSchedule" type="success">미등록수정</base-button>-->
          <base-button @click="rejectSchedule" type="danger">반려</base-button>
          <base-button @click="goBack" type="default">뒤로</base-button>
        </form>
        <!-- end card -->
      </div>
    </div>
    <ScheduleSuggestionModal
      :shouldShow="confirmModal.show"
      :messages="confirmModal.messages"
      :onConfirm="onConfirmModal"
      :onCancel="onCancelModal"
    ></ScheduleSuggestionModal>
  </div>
</template>
<script>
import TemplateSelect from "@/pages/Components/TemplateSelect.vue";
import { Card, BaseInput, BaseButton, BaseSwitch } from "@/components/index";

import ScheduleSuggestionModal from "./ScheduleSuggestionModal";

import * as moment from "moment";

import { Cropper } from "vue-advanced-cropper";

import { Toast } from "@/util/Toast";

import BlipFileUploadZone from "@/components/BlipFileUploadZone";

import draggable from "vuedraggable";
import { TemplateLocation } from "@/pages/Components/TemplateSelect";
import * as _ from "lodash";
import { showAPIErrorToast } from "@/util/ErrorUtils";

const CONFIRM_MODE_APPROVAL = "approval"; //스케줄 승인(스케줄 추가 또는 변경됨) + 알림
const CONFIRM_MODE_REJECTION = "rejection"; //반려
const CONFIRM_MODE_ACCEPT = "accept"; //스케줄 승인(변경은 안함) + 알림

export default {
  components: {
    TemplateSelect,
    ScheduleSuggestionModal,
    Card,
    BaseButton,
    BaseInput,
    BaseSwitch,
    BlipFileUploadZone,
    draggable,
    Cropper,
  },
  async created() {
    if (this.$route.query.unitId) {
      this.unitId = this.$route.query.unitId;
    }
    if (this.$route.query.suggestionId) {
      this.suggestionId = this.$route.query.suggestionId;
      await this.getScheduleSuggestion();
      await this.getScheduleSuggestions();
    }
    await this.getScheduleTypes();
    await this.getScheduleMetadataTypes();
    await this.getMembers();
    await this.getScheduleNotificationTypes();
  },
  data() {
    return {
      unitId: null,
      userId: null,
      nickname: null,
      suggestionId: null,
      scheduleId: null,
      scheduleType: "",
      scheduleTypes: [],
      scheduleMetadataType: null,
      scheduleMetadataTypes: [],
      scheduleNotificationTypes: {
        typeIds: [],
        options: [],
      },
      scheduleNotificationTimes: [],
      contentTypes: [
        { type: "I", name: "이미지" },
        { type: "V", name: "비디오" },
        { type: "T", name: "텍스트" },
      ],
      ratios: [
        { value: null, label: "원본" },
        { value: 1, label: "1:1" },
        { value: 2, label: "16:9" },
        { value: 3, label: "4:3" },
        { value: 4, label: "3:4" },
        { value: 5, label: "9:16" },
      ],
      ratioValues: [
        {
          key: 1,
          value: 1,
        },
        {
          key: 2,
          value: 1.78,
        },
        {
          key: 3,
          value: 1.33,
        },
        {
          key: 4,
          value: 0.75,
        },
        {
          key: 5,
          value: 0.56,
        },
      ],
      location: {
        type: 2,
        options: [
          { label: "없음", value: null },
          { label: "장소", value: 1 },
          { label: "채널", value: 2 },
        ],
        name: null,
      },
      title: null,
      unitName: null,
      content: null,
      isSaveAll: false,
      repeat: {
        repeatId: null,
        repeatStartDate: null,
        repeatEndDate: null,
        options: [
          { label: "없음", value: null },
          { label: "매일", value: "d" },
          { label: "매주", value: "w" },
          { label: "매월", value: "m" },
          { label: "매년", value: "y" },
        ],
      },
      members: [],
      loadedMembers: [],
      contents: [],
      isImportant: false,
      isShow: true,
      isAllday: false,
      isEndTimeHidden: true,
      startTime: null,
      endTime: null,
      openTime: null,
      confirmModal: {
        show: false,
        mode: "approval",
        messages: [],
        report: null,
      },
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
        },
        {
          prop: "scheduleId",
          label: "스케줄ID",
          minWidth: 50,
        },
        {
          prop: "startTime",
          label: "시작일",
          minWidth: 150,
        },
        {
          prop: "endTime",
          label: "종료일",
          minWidth: 150,
        },
        {
          prop: "title",
          label: "제목",
          minWidth: 120,
        },
        {
          prop: "memberName",
          label: "관련멤버",
          minWidth: 120,
        },
        {
          prop: "type",
          label: "타입",
          minWidth: 120,
        },
        {
          prop: "userId",
          label: "유저아이디",
          minWidth: 120,
        },
        {
          prop: "nickname",
          label: "닉네임",
          minWidth: 120,
        },
      ],
      events: [],
    };
  },
  watch: {
    async countryCode(a, b) {
      await this.getCities();
    },
    isSaveAll() {
      if (!this.isSaveAll) {
        this.repeat.repeatId = null;
      }
    },
    scheduleType(newVal, oldVal) {
      if (oldVal === "" || newVal === oldVal) return;

      if (newVal && this.selectedScheduleMetadataTypes.length > 0) {
        this.scheduleMetadataType = null;
      }
    },
  },
  computed: {
    selectedScheduleMetadataType() {
      return this.scheduleMetadataTypes.find((item) => item.id === this.scheduleMetadataType) || {};
    },

    selectedScheduleMetadataTypes() {
      const data = this.scheduleMetadataTypes.filter((item) => item.scheduleType === parseInt(this.scheduleType, 10));
      if (data.length > 0) {
        return [{ id: null, name: "없음" }, ...data];
      }
      return [];
    },
  },

  methods: {
    handleSelectionChange(rows) {
      if (rows.length === 0) {
        for (const event of this.events) {
          event.checked = false;
        }
      } else {
        for (const row of rows) {
          if (row.id) {
            row.checked = !row.checked;
          }
        }
      }
    },
    addContent() {
      this.contents.push({ contentType: "I", ratio: null });
    },
    removeContent(index) {
      if (index !== -1) {
        this.contents.splice(index, 1);
      }
    },
    async onRatioChange(content) {
      console.log(content);
      if (content.ratio) {
        this.ratioValues.forEach((ratio) => {
          if (ratio.key === content.ratio) {
            content.aspectRatio = ratio.value;
          }
        });
      } else {
        await this.$axios.put(`/common/fileMetadata`, { fileId: content.imageFileId, extMetadata: null });
      }
    },
    onCropperChange(a, b) {
      console.log(a, b);
    },
    async cropImage(fileId, index) {
      const { coordinates } = this.$refs["cropper" + index][0].getResult();
      const display = { x: coordinates.left, y: coordinates.top, width: coordinates.width, height: coordinates.height };
      const extMetadata = { display };
      await this.$axios.put(`/common/fileMetadata`, { fileId, extMetadata });
      Toast.success("표시영역이 저장되었어요");
    },
    onChangeContentType(index) {
      const content = this.contents[index];
      console.log(index);
      if (content.extMetadata) {
        const extMetadata = JSON.parse(content.extMetadata);
        const me = this;
        console.log(extMetadata);
        if (content.contentType === "I") {
          setTimeout(function () {
            me.$refs["cropper" + index][0].setCoordinates(
              {
                width: extMetadata.display.width,
                height: extMetadata.display.height,
                left: extMetadata.display.x,
                top: extMetadata.display.y,
              },
              1000
            );
          });
        }
      }
    },
    onMediaFileIdChange(newFileIds, index) {
      this.contents[index].imageFileId = newFileIds[0];
      this.contents[index].imageUrl = window.Endpoints.imageServerUrl + newFileIds[0];
    },
    getMetadata(url, index) {
      if (url === "" || url === null) {
        Toast.error("url을 입력해주세요");
        return;
      }
      return this.$axios.get(`/common/metadata?url=${url}`).then((res) => {
        const data = res.data.data;
        this.contents[index].imageUrl = data.image;
        this.contents[index].imageFileId = null;
        this.contents[index].path = null;
        this.contents[index].path = url;
      });
    },
    async getScheduleSuggestion() {
      return this.$axios.get(`/schedule/suggestions/${this.suggestionId}`, { params: { unitId: this.unitId } }).then((res) => {
        const data = res.data.data;
        if (!data) {
          return;
        }
        if (data.scheduleId) {
          this.scheduleId = data.scheduleId;
        }
        this.userId = data.userId;
        this.nickname = data.nickname;
        this.title = data.title;
        this.unitName = data.unitName;
        this.content = data.message;
        this.location.name = data.locationName;
        this.isAllday = data.isAllday === 1;
        this.isEndTimeHidden = 1;
        this.startTime = data.startTime;
        this.endTime = data.endTime ?? data.startTime;
        this.userId = data.userId;
        this.loadedMembers = data.members;
        this.contents = data.contents.map((content, index) => {
          if (content.imageFileId) {
            content.imageUrl = window.Endpoints.imageServerUrl + content.imageFileId;
          }
          content.ratio = null;
          return content;
        });
      });
    },

    applyTemplate(data) {
      const location = data.location;
      if (location === TemplateLocation.ADD) {
        if (this.content) {
          this.content += "\n" + data.contents;
        } else {
          this.content = data.contents;
        }
      } else if (location === TemplateLocation.OVERWRITE) {
        this.content = data.contents;
      } else if (location === TemplateLocation.BOTTOM) {
        if (this.contents.length === 0) {
          Toast.error("컨텐츠가 없어요");
        } else if (_.filter(this.contents, { contentType: "T" }).length === 0) {
          Toast.error("텍스트 타입 컨텐츠가 없어요");
        } else {
          if (_.last(_.filter(this.contents, { contentType: "T" })).description) {
            _.last(_.filter(this.contents, { contentType: "T" })).description += "\n" + data.contents;
          } else {
            _.last(_.filter(this.contents, { contentType: "T" })).description = data.contents;
          }
          this.isVisible = !this.isVisible;
          this.isVisible = !this.isVisible;
        }
      }
    },

    async getScheduleSuggestions() {
      if (!this.unitId) {
        return;
      }
      const startDate = moment(this.startTime).add(-1, "day");
      const endDate = moment(this.startTime).add(1, "day");
      const startTime = moment(`${moment(startDate).year()}-${moment(startDate).month() + 1}-${moment(startDate).date()} 00:00:00`).toISOString();
      const endTime = moment(`${moment(endDate).year()}-${moment(endDate).month() + 1}-${moment(endDate).date()} 23:59:59`).toISOString();

      return this.$axios
        .get("/schedule/suggestions", {
          params: { unitId: this.unitId, startTime, endTime },
        })
        .then((res) => {
          this.events = [];
          const data = res.data.data;
          data.forEach((d) => {
            const obj = {};
            obj.id = d.suggestionId;

            obj.scheduleId = d.scheduleId;
            for (let i = 0; i < this.scheduleTypes.length; i++) {
              const type = this.scheduleTypes[i];
              if (d.typeId === type.id) {
                obj.type = type.name;
                break;
              }
            }
            obj.title = d.title;
            obj.userId = d.userId;
            obj.nickname = d.nickname;
            obj.start = d.startTime;
            obj.end = d.endTime;
            obj.allDay = d.isAllDay === 1;
            obj.isEndTimeHidden = d.isEndTimeHidden === 1;
            obj.members = d.members;
            obj.state = d.state;
            obj.startTime = moment(d.startTime).format("Y-MM-DD HH:mm:ss");
            obj.endTime = moment(d.endTime).format("Y-MM-DD HH:mm:ss");
            obj.checked = false;
            if (obj.members.length > 0) {
              obj.memberName = "";

              obj.members.forEach((item) => {
                obj.memberName += item.name;
              });
            } else {
              obj.memberName = "전체";
            }
            if (d.suggestionId !== this.suggestionId) {
              this.events.push(obj);
            }
          });
        });
    },
    async getScheduleTypes() {
      return this.$axios.get("/schedule/scheduleTypes").then((res) => {
        this.scheduleTypes = res.data.data;
      });
    },

    async getScheduleMetadataTypes() {
      return this.$axios.get("/schedule/getScheduleMetadataTypes").then((res) => {
        this.scheduleMetadataTypes = res.data.data;
      });
    },

    async getMembers() {
      return this.$axios.get(`/artistUnit/${this.unitId}/members`, null).then((res) => {
        const data = res.data.data;
        if (data.length > 0) {
          data
            .filter((item) => item.isVisible === 1)
            .forEach((item) => {
              const option = {};
              option.name = item.blipName ? item.blipName : item.name;
              option.id = item.artistId;
              option.value = false;
              if (this.loadedMembers?.length > 0) {
                this.loadedMembers.forEach((m) => {
                  if (item.artistId === m) {
                    option.value = true;
                  }
                });
              }
              this.members.push(option);
            });
        }
      });
    },

    async getScheduleNotificationTypes() {
      return this.$axios.get("/schedule/scheduleNotificationTypes").then((res) => {
        const data = res.data.data;
        this.scheduleNotificationTypes.options = data.map((d) => {
          d.value = d.id;
          d.label = d.name;
          return d;
        });
      });
    },

    async onSubmit() {
      if (!this.unitId) {
        Toast.error("잘못된 접근입니다");
        return;
      }
      if (this.scheduleType === "" || !this.scheduleType) {
        Toast.error("스케줄 타입을 지정해주세요 ");
        return;
      }
      if (this.title === "" || !this.title) {
        Toast.error("타이틀을 입력해주세요");
        return;
      }
      if (!this.startTime || !this.endTime) {
        Toast.error("스케줄 시간을 입력해주세요");
        return;
      }
      if (new Date(this.startTime) > new Date(this.endTime)) {
        Toast.error("종료시간이 시작시간보다 빨라요");
        return;
      }
      if (this.repeat.repeatId) {
        if (!this.repeat.repeatStartDate || !this.repeat.repeatEndDate) {
          Toast.error("스케줄 반복기간을 지정해주세요 ");
          return;
        }
        if (new Date(this.repeat.repeatStartDate) > new Date(this.repeat.repeatEndDate)) {
          Toast.error("반복 종료시간이 시작시간보다 빨라요");
          return;
        }
      }
      if (this.contents.length > 0) {
        const contents = this.contents;
        for (let i = 0; i < contents.length; i++) {
          const content = contents[i];
          if (content.contentType === "I") {
            if (!content.imageFileId && !content.imageUrl) {
              Toast.error("컨텐츠 이미지를 등록해주세요");
              return;
            }
          } else if (content.contentType === "V") {
            if (!content.imageFileId && !content.imageUrl) {
              Toast.error("컨텐츠 이미지를 등록해주세요");
              return;
            }
            if (!content.path) {
              Toast.error("컨텐츠 URL을 등록해주세요");
              return;
            }
          } else if (content.contentType === "T") {
            if (!content.description || content.description === "") {
              Toast.error("컨텐츠 텍스트를 등록해주세요");
              return;
            }
          }
        }
      }
      this.onClickApprove();
    },
    async sendSubmitSchedule(message) {
      const param = {};
      if (this.isAllday) {
        this.startTime = moment(this.startTime).hours(0).minutes(0).toISOString();
        this.endTime = moment(this.endTime).hours(0).minutes(0).toISOString();
      }
      param.type = this.scheduleType;
      param.scheduleNotificationTypes = [];
      if (this.scheduleMetadataType && this.selectedScheduleMetadataTypes.length > 0) {
        param.metadata = {
          scheduleMetadataType: this.scheduleMetadataType,
          countryCode: this.countryCode,
          city: this.city,
        };
      }
      if (this.scheduleNotificationTypes.typeIds.length > 0) {
        this.scheduleNotificationTypes.typeIds.forEach((typeId) => {
          this.scheduleNotificationTypes.options.forEach((type) => {
            if (typeId === type.id) {
              // 시작시간 기준
              if (type.timeStandard === 1) {
                param.scheduleNotificationTypes.push({
                  notificationType: type.id,
                  notificationTime: moment(this.startTime).add(type.timeInterval, "minutes").second(0),
                });
              }
              // 종료시간 기준
              else if (type.timeStandard === 2) {
                param.scheduleNotificationTypes.push({
                  notificationType: type.id,
                  notificationTime: moment(this.endTime).add(type.timeInterval, "minutes").second(0),
                });
              }
            }
          });
        });
      }
      param.title = this.title;
      param.content = this.content;
      param.contents = this.contents.map((content) => {
        if (content.ratio) {
          this.ratioValues.forEach((ratio) => {
            if (ratio.key === content.ratio) {
              content.ratio = ratio.value;
            }
          });
        }
        return content;
      });
      if (this.location.type) {
        param.locationType = this.location.type;
        param.locationName = this.location.name;
      } else {
        param.locationType = null;
        param.locationName = null;
      }
      param.members = [];
      this.members.forEach((m) => {
        if (m.id !== "") {
          if (m.value) {
            param.members.push(m.id);
          }
        }
      });
      param.isShow = this.isShow ? 1 : 0;
      param.isImportant = this.isImportant ? 1 : 0;
      param.isAllday = this.isAllday ? 1 : 0;
      param.isEndTimeHidden = this.isEndTimeHidden ? 1 : 0;
      param.startTime = this.startTime;
      param.endTime = this.endTime;
      param.openTime = this.openTime;
      if (this.repeat.repeatId) {
        if (this.repeatStartDate < this.repeatStartDate) {
          Toast.error("반복종료가 반복시작보다 빨라요 ");
          return;
        }
        param.periodUnit = this.repeat.repeatId;
        param.repeatStartDate = this.repeat.repeatStartDate;
        param.repeatEndDate = this.repeat.repeatEndDate;
      }
      const suggestionIds = [this.suggestionId];
      const userIds = [this.userId];
      for (var i = 0; i < this.events.length; i++) {
        if (this.events[i].checked) {
          suggestionIds.push(this.events[i].id);
          userIds.push(this.events[i].userId);
        }
      }

      param.suggestionIds = suggestionIds;
      param.userIds = userIds;
      param.suggestionId = this.suggestionId;
      param.scheduleId = this.scheduleId;
      if (message) {
        param.notification = message.notification;
        param.message = message.message;
      }

      return this.$axios.post(`/schedule/suggestions/${this.unitId}`, { param });
    },

    acceptSchedule() {
      if (!this.unitId || !this.suggestionId) {
        Toast.error("잘못된 접근입니다");
        return;
      }
      this.onClickAccept();
    },
    rejectSchedule() {
      if (!this.unitId || !this.suggestionId) {
        Toast.error("잘못된 접근입니다");
        return;
      }
      this.onClickReject();
    },

    async sendRejectSchedule(message) {
      const param = {};
      const suggestionIds = [this.suggestionId];
      const userIds = [this.userId];
      for (var i = 0; i < this.events.length; i++) {
        if (this.events[i].checked) {
          suggestionIds.push(this.events[i].id);
          userIds.push(this.events[i].userId);
        }
      }

      param.suggestionIds = suggestionIds;
      param.userIds = userIds;
      if (message) {
        param.notification = message.notification;
        param.message = message.message;
      }

      return this.$axios.post(`/schedule/suggestions/${this.unitId}/reject`, { param }).then((res) => {});
    },

    async sendAcceptSchedule(message) {
      const param = {};
      const suggestionIds = [this.suggestionId];
      const userIds = [this.userId];
      for (var i = 0; i < this.events.length; i++) {
        if (this.events[i].checked) {
          suggestionIds.push(this.events[i].id);
          userIds.push(this.events[i].userId);
        }
      }

      param.suggestionIds = suggestionIds;
      param.userIds = userIds;
      if (message) {
        param.notificationTitle = message.split("\n")[0];
        param.notificationMessage = message.split("\n")[1];
      }
      return this.$axios.post(`/schedule/suggestions/${this.unitId}/accept`, { param }).then((res) => {});
    },

    tableRowClassName({ row }) {
      if (row.state === 1) {
        if (row.scheduleId) {
          return "modify-row";
        } else {
          return "add-row";
        }
      } else {
        return "";
      }
    },
    goBack() {
      history.go(-1);
    },

    showOriginalSchedule() {
      //const routeData = this.$router.resolve({name: 'routeName', query: {data: "someData"}});
      // window.open(routeData.href, '_blank');
      window.open(`/schedules/scheduleForm?scheduleId=${this.scheduleId}&unitId=${this.unitId}`);
    },

    onClickApprove() {
      this.showConfirmModal(CONFIRM_MODE_APPROVAL, [
        {
          notification: {
            titles: {
              ko: "덕분에 정보가 더 정확해졌어요! ",
              en: "Thanks to you, the info is now more accurate!",
              ja: "おかげで情報がもっと正確になりました！",
            },
            bodies: {
              ko: `감사의 마음으로 50 블링을 드릴게요.`,
              en: `We’re sending you 50 Bling to say thanks.`,
              ja: `感謝の気持ちとして50ブリングをプレゼントします。`,
            },
          },
          message: {
            ko: `안녕하세요 블립이에요. ᐢ•ᴗ•

덕분에 정보가 더 정확해졌어요! ✨

소중한 제보 정말 감사드려요, ${this.nickname}님 😊

감사의 마음으로 50 블링을 선물로 드렸어요!

앞으로도 함께 완벽한 스케줄을 만들어가요~💫`,
            en: `Hi, this is blip! ᐢ•ᴗ•

Thanks to you, the info just got more accurate! ✨

Really appreciate your tip, ${this.nickname}😊

As a thank-you, we've sent you 50 bling!

Let’s keep building the perfect schedule together~💫`,
            ja: `こんにちは、blipです！ᐢ•ᴗ•

おかげで情報がもっと正確になりました✨
素敵なご報告、本当にありがとうございます、${this.nickname}さん 😊
感謝の気持ちとして50ブリングをプレゼントしました！
これからも一緒に完璧なスケジュールを作っていきましょう〜💫`,
          },
        },
      ]);
    },
    onClickReject() {
      this.showConfirmModal(CONFIRM_MODE_REJECTION, [
        {
          notification: {
            titles: {
              ko: `제보 감사해요!`,
              en: `Thanks for the tip!`,
              ja: `ご報告ありがとうございます！`,
            },
            bodies: {
              ko: `아쉽지만 ${this.title} 스케줄이 이미 등록되어 있어요.`,
              en: `Sadly, the ${this.title} schedule is already registered.`,
              ja: `残念ですが ${this.title}のスケジュールはすでに登録されています。`,
            },
          },
          message: {
            ko: `안녕하세요 블립이에요. ᐢ•ᴗ•

제보 감사해요, ${this.nickname}님! 🙏

아쉽지만 ${this.title} 스케줄은 이미 등록되어 있었어요.

그래도 빠르게 확인해 주셔서 든든했답니다!`,
            en: `Hi, this is blip! ᐢ•ᴗ•

Thanks for the tip, {{닉네임}}! 🙏

Unfortunately, the ${this.title} schedule is already listed.

Still, it was super helpful to have your quick check!`,
            ja: `こんにちは、blipです！ᐢ•ᴗ•ᐢ

ご報告ありがとうございます、${this.nickname}さん！🙏

残念ですが、${this.title}のスケジュールはすでに登録されています。

でも、すぐに確認してくれてとても心強かったです！`,
          },
        },
        {
          notification: {
            titles: {
              ko: `제보 감사해요!`,
              en: `Thanks for the report! `,
              ja: `ご報告ありがとうございます！`,
            },
            bodies: {
              ko: `아쉽지만 내용이 정확하지 않아 반영할 수 없어요. `,
              en: `Unfortunately, the details aren’t accurate enough to apply.`,
              ja: `申し訳ないですが、内容が正確でないため反映できませんでした。`,
            },
          },
          message: {
            ko: `안녕하세요 블립이에요. ᐢ•ᴗ•

소중한 제보 고맙습니다!

다만 아쉽게도 이번에는 정보가 조금 정확하지 않아서 반영이 어려웠어요 😢

혹시 다른 정보가 있다면 언제든지 알려주세요!

블립은 언제나 ${this.nickname}님의 제보를 기다리고 있어요 🌟`,
            en: `Hi, this is blip! ᐢ•ᴗ•

Thanks so much for your thoughtful tip!

Unfortunately, this time the info wasn't clear enough to be added 😢

If you have any updates, feel free to let me know anytime!

blip is always here and waiting for your insights, ${this.nickname} 🌟`,
            ja: `こんにちは、blipです！ᐢ•ᴗ•

大切なご報告、ありがとうございます！

でも今回は情報が少し不正確だったため、反映が難しかったです 😢

もし他の情報があれば、いつでも教えてくださいね！

blipはいつでも${this.nickname}さんのご報告をお待ちしています 🌟`,
          },
        },
      ]);
    },
    onClickAccept() {
      this.showConfirmModal(CONFIRM_MODE_ACCEPT, [`[${this.unitName}] 덕분에 블립이 더욱 똑똑해졌어요 🤓\n '${this.title}' 내용 업데이트`]);
    },
    showConfirmModal(mode, messages) {
      this.confirmModal.mode = mode;
      this.confirmModal.messages = messages;

      this.confirmModal.show = true;
    },
    async onConfirmModal(message) {
      this.confirmModal.show = false;

      let isSucceeded = true;

      if (this.confirmModal.mode === CONFIRM_MODE_APPROVAL) {
        try {
          await this.sendSubmitSchedule(message);

          // Toast.success("등록 되었습니다.");
        } catch (err) {
          isSucceeded = false;
          // Toast.error("등록실패 하습니다.");
        } finally {
          Toast.success("등록 되었습니다.");
          history.go(-1);
        }
      } else if (this.confirmModal.mode === CONFIRM_MODE_REJECTION) {
        try {
          await this.sendRejectSchedule(message);

          // Toast.success("반려 처리에 성공하였습니다.");
        } catch (err) {
          isSucceeded = false;
          // Toast.error("반려 처리에 실패 했습니다.");
        } finally {
          Toast.success("반려 처리에 성공하였습니다.");
          history.go(-1);
        }
      } else if (this.confirmModal.mode === CONFIRM_MODE_ACCEPT) {
        try {
          await this.sendAcceptSchedule(message);

          // Toast.success("반려 처리에 성공하였습니다.");
        } catch (err) {
          isSucceeded = false;
          // Toast.error("반려 처리에 실패 했습니다.");
        } finally {
          Toast.success("알림이 전송 되었습니다.");
          history.go(-1);
        }
      }

      if (isSucceeded) {
        history.go(-1);
      }
    },
    async onCancelModal() {
      this.confirmModal.show = false;
    },
  },
};
</script>
<style>
.bootstrap-switch {
  margin: 6px;
}
.el-table .modify-row td div {
  color: #2600ff !important;
}

.el-table .add-row td div {
  color: red !important;
}

.el-table .form-check {
  margin-top: 25px !important;
}
</style>
